import { useCallback } from 'react';

import { useCurrentMerchantAccount } from 'data/merchant/hooks/useCurrentMerchantAccount';
import {
  AnalyticsEventType,
  trackEvent,
  unidentifiedEvents,
  trackUserEvent,
} from 'utils/analytics';
import { isSuccess } from 'utils/remote';

export function useMerchantEvent() {
  const remote = useCurrentMerchantAccount();

  return useCallback(
    async (
      event: AnalyticsEventType,
      payload: Record<string, unknown> = {},
    ) => {
      if (isSuccess(remote)) {
        await trackUserEvent(remote.data.id, event, payload);
      }
    },
    [remote],
  );
}

export async function replayUnidentifiedEvents() {
  await Promise.all(
    unidentifiedEvents.map(async ({ type, payload }) => {
      await trackEvent(type, payload);
    }),
  );
}
